import React from 'react';

const Icon = ({ value, className, ...props }) =>
  <i className={`icon bbico-${value} ${className}`} {...props} />;

export default Icon;
